import { useLocation, useNavigate } from 'react-router-dom';

import config from '@occc/config';
import {
  Page,
  Button,
  Typography,
  Link,
  Card,
  CardContent,
  CardActions,
} from '@occc-app/design-system';

const fromPath = (pathname: string) => (
  <Typography>
    Sorry, no page exists at{' '}
    <Typography variant='subtitle1' component='span'>
      {pathname}
    </Typography>
    . If you repeatedly reach this page from an outside link, please{' '}
    <Link href='mailto:support@hatchloyalty.com'>contact us</Link>!
  </Typography>
);

const fromResource = (resource: string, id: string) => {
  return (
    <>
      <Typography paragraph>
        It looks like you were trying to find a{' '}
        <Typography variant='subtitle1' component='span'>
          {resource}
        </Typography>{' '}
        with the id{' '}
        <Typography variant='subtitle1' component='span'>
          {id}
        </Typography>
        . Unfortunately a {resource} with that id does not exist. If manually entered, please ensure
        that the entire id was typed in to your browser.
      </Typography>
      <Typography paragraph>
        It's also possible that the id exists in your program in a separate environment. You may
        have sandbox, staging, and/or production environments. This environment is the{' '}
        <Typography variant='subtitle1' component='span'>
          {config.env}
        </Typography>{' '}
        environment.
      </Typography>
      <Typography paragraph>
        If you clicked a link within the Activate Command Center and found this instead, please{' '}
        <Link href='mailto:support@hatchloyalty.com'>contact us</Link>!
      </Typography>
    </>
  );
};

export const NotFound = () => {
  const { pathname, search: queryString } = useLocation();
  const navigate = useNavigate();

  const goHome = () => navigate('/');

  let title;
  let body;

  if (pathname === '/not-found') {
    // Is this option is still the case? I believe it was used by old offers api
    // calls when the route had been used as a api route
    const query = new URLSearchParams(queryString);
    const resource = query.get('resource') || 'none';
    const id = query.get('id') || 'none';

    title = 'Foo Not Found';
    body = fromResource(resource, id);
  } else {
    title = 'Page Not Found';
    body = fromPath(pathname);
  }

  return (
    <Page browserTabTitle={title} pageHeaderProps={{ title }}>
      <Card>
        <CardContent>{body}</CardContent>
        <CardActions>
          <Button variant='contained' onClick={goHome}>
            Return Home
          </Button>
        </CardActions>
      </Card>
    </Page>
  );
};
